import { queryDriverDayWorkTime, selectDriverAllWorkRecord,queryMistakePageByDriver,queryDriverCountPeriodRate,queryDriverCountMistakePeriod,SelectDriverTodayMistakeCountPage,SelectDriverTodayWorkTimePage,selectDriverDailyUseRate,selectDriverUseRatePage,selectDriverTimeOrder,selectDriverAlarmOrder,selectDriverCardOrder,selectDriverOrderList } from "../../api/config/modules/DriverAnalysis";

const state = {
    selectDriverTimeOrder: {},
    selectDriverAlarmOrder: {},
    selectDriverCardOrder: {},
    selectDriverOrderList: {},
    selectDriverDailyUseRate: {},
    selectDriverUseRatePage: {},
    SelectDriverTodayWorkTimePage: {},
    SelectDriverTodayMistakeCountPage: {},
    queryDriverCountMistakePeriod: {},
    queryDriverCountPeriodRate: {},
    queryMistakePageByDriver: {},
    selectDriverAllWorkRecord: {},
    queryDriverDayWorkTime: {}
};

const mutations = {
  SET_DRIVERTIMEORDER: (state, selectDriverTimeOrder) => {
    state.selectDriverTimeOrder = selectDriverTimeOrder;
  },
  SET_DRIVERALARMORDER: (state, selectDriverAlarmOrder) => {
    state.selectDriverAlarmOrder = selectDriverAlarmOrder;
  },
  SET_DRIVERCARDORDER: (state, selectDriverCardOrder) => {
    state.selectDriverCardOrder = selectDriverCardOrder;
  },
  SET_DRIVERORDERLIST: (state, selectDriverOrderList) => {
    state.selectDriverOrderList = selectDriverOrderList;
  },
  SET_SELECTDRIVERDAILYUSRRATE: (state, selectDriverDailyUseRate) => {
    state.selectDriverDailyUseRate = selectDriverDailyUseRate;
  },
  SET_SELECTDRIVERUSRRATEPAGE: (state, selectDriverUseRatePage) => {
    state.selectDriverUseRatePage = selectDriverUseRatePage;
  },
  SET_SELECTDRIVERTODAYWORKTIMEPAGE: (state, SelectDriverTodayWorkTimePage) => {
    state.SelectDriverTodayWorkTimePage = SelectDriverTodayWorkTimePage;
  },
  SET_SELECTDRIVERTODAYMISTAKECOUNTPAGE: (state, SelectDriverTodayMistakeCountPage) => {
    state.SelectDriverTodayMistakeCountPage = SelectDriverTodayMistakeCountPage;
  },
  SET_QUERYDRIVERCOUNTMISTAKEPERIOD: (state, queryDriverCountMistakePeriod) => {
    state.queryDriverCountMistakePeriod = queryDriverCountMistakePeriod;
  },
  SET_QUERYDRIVERCOUNTPERIODRATE: (state, queryDriverCountPeriodRate) => {
    state.queryDriverCountPeriodRate = queryDriverCountPeriodRate;
  },
  SET_QUERYMISTAKEPAGEBYDRIVER: (state, queryMistakePageByDriver) => {
    state.queryMistakePageByDriver = queryMistakePageByDriver;
  },
  SET_SELECTDRIVERALLWORKRECORD: (state, selectDriverAllWorkRecord) => {
    state.selectDriverAllWorkRecord = selectDriverAllWorkRecord;
  },
  SET_QUERYDRIVERDAYWORKTIME: (state, queryDriverDayWorkTime) => {
    state.queryDriverDayWorkTime = queryDriverDayWorkTime;
  },
};

const actions = {
  GET_DRIVERTIMEORDER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectDriverTimeOrder(data)
        .then((res) => {
          commit("SET_DRIVERTIMEORDER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DRIVERALARMORDER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverAlarmOrder(data)
        .then((res) => {
          commit("SET_DRIVERALARMORDER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DRIVERCARDORDER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectDriverCardOrder(data)
        .then((res) => {
          commit("SET_DRIVERCARDORDER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DRIVERORDERLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverOrderList(data)
        .then((res) => {
          commit("SET_DRIVERORDERLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERDAILYUSRRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverDailyUseRate(data)
        .then((res) => {
          commit("SET_SELECTDRIVERDAILYUSRRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERUSRRATEPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverUseRatePage(data)
        .then((res) => {
          commit("SET_SELECTDRIVERUSRRATEPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERTODAYWORKTIMEPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      SelectDriverTodayWorkTimePage(data)
        .then((res) => {
          commit("SET_SELECTDRIVERTODAYWORKTIMEPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERTODAYMISTAKECOUNTPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      SelectDriverTodayMistakeCountPage(data)
        .then((res) => {
          commit("SET_SELECTDRIVERTODAYMISTAKECOUNTPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYDRIVERCOUNTMISTAKEPERIOD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryDriverCountMistakePeriod(data)
        .then((res) => {
          commit("SET_QUERYDRIVERCOUNTMISTAKEPERIOD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYDRIVERCOUNTPERIODRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryDriverCountPeriodRate(data)
        .then((res) => {
          commit("SET_QUERYDRIVERCOUNTPERIODRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYMISTAKEPAGEBYDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryMistakePageByDriver(data)
        .then((res) => {
          commit("SET_QUERYMISTAKEPAGEBYDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERALLWORKRECORD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverAllWorkRecord(data)
        .then((res) => {
          commit("SET_SELECTDRIVERALLWORKRECORD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYDRIVERDAYWORKTIME: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryDriverDayWorkTime(data)
        .then((res) => {
          commit("SET_QUERYDRIVERDAYWORKTIME", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
